class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.cartNotificationButton = document.getElementById('cart-notification-button');
    
    this.cartUpdatedListener = this.onCartUpdated.bind(this);
    document.addEventListener('cart:updated', this.cartUpdatedListener);
  }

  connectedCallback() {
    this.renderContentsFromCart();
  }

  onCartUpdated(evt) {
    const cartState = evt?.detail?.cart;

    // ✅ Only render if sections exist
    if (cartState && cartState.sections) {
      this.renderContents({
        id: cartState.id,
        sections: cartState.sections
      });
    }
  }

  renderContentsFromCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // ❌ DO NOT try to render sections from /cart.js
        // ✅ Only update ID (optional)
        this.productId = cart.id;
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    const defaultEl = document.getElementById("cart-notification-default");
    if (defaultEl) defaultEl.innerHTML = "";

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      const html = parsedState.sections[section.id];

      if (!html) {
        container.innerHTML = "";
        return;
      }

      const content = this.getSectionInnerHTML(html, section.selector);
      if (content) {
        container.innerHTML = content;
      }
    });

    // ✅ Safe dropdown open
    const dropDownIcon = document.querySelector('#cart-icon-bubble');
    if (dropDownIcon && dropDownIcon.getAttribute("aria-expanded") === "false") {
      dropDownIcon.click();
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
      { id: 'cart-upsell' },
      { id: 'cart-drawer-gift' }
    ];
  }

  getSectionInnerHTML(html, selector = 'body') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : "";
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.cartUpdatedListener);
  }
}

customElements.define('cart-notification', CartNotification);